import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeCs from '@angular/common/locales/cs';
import { ErrorHandler, inject, LOCALE_ID, NgModule, provideAppInitializer } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';
import { CoreLegacyModule } from '@isophi/core-legacy';
import { APP_CONFIG, AppConfig } from '@isophi/core-ui';
import { BASE_PATH } from '@isophi/isophi-pdfs-api';
import { ApiModule as MngApiModule, BASE_PATH as BASE_PATH_MNG_CONFIG, Configuration as MngConfig } from '@isophi/mng-api';
import * as sentry from '@sentry/angular';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { NgxSpinnerModule } from 'ngx-spinner';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { ApiInterceptor } from './core/guards/api.interceptor';
import { InitService } from './core/services/init.service';
import { LayoutModule } from './modules/layout/layout.module';
import { TransitionReportModule } from './modules/transition-report/transition-report.module';
import { SharedModule } from './shared/shared.module';
import { TranslocoRootModule } from './transloco-root.module';

registerLocaleData(localeCs, 'cs');

export function initApplication(initService: InitService) {
  return () => initService.initApplication();
}
export const mngConfigFactory = (): MngConfig => new MngConfig({ apiKeys: {} });

@NgModule({
  declarations: [AppComponent],
  imports: [
    CoreLegacyModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    TranslocoRootModule,
    SharedModule.forRoot(),
    AppRoutingModule,
    NgxSpinnerModule,
    HttpClientModule,
    FormsModule,
    NgxGoogleAnalyticsModule.forRoot(environment.ga_measurement_id),
    NgxGoogleAnalyticsRouterModule,
    LayoutModule,
    MngApiModule,
    TransitionReportModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: sentry.createErrorHandler(),
    },
    {
      provide: sentry.TraceService,
      deps: [Router],
    },
    { provide: BASE_PATH, useValue: environment.pdfApiBase },
    { provide: LOCALE_ID, useValue: 'cs' },
    provideAppInitializer(() => {
        inject(sentry.TraceService);
        const initializerFn = (initApplication)(inject(InitService));
        return initializerFn();
      }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    {
      provide: APP_CONFIG,
      useValue: {
        i18n: environment.i18n,
      } as AppConfig,
    },
    // management-api configuration
    { provide: MngConfig, useFactory: mngConfigFactory },
    { provide: BASE_PATH_MNG_CONFIG, useFactory: () => environment.managementApiBase },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
